<template>
<div>
 <div class="page black colophon">

        <div class="sitemap">
            <router-link to="/">
            <h1><router-link to="/">The Studio</router-link></h1>
            <li>About</li>
            <li>Rooms</li>
            <li>Location</li> 
            <li>Services</li> 
            <li>Equipment</li>
            </router-link>
        </div>
        <!-- <div class="sitemap">
            <h1><router-link to="/services">Services</router-link></h1> -->
            <!-- <li>Pre-production</li>
            <li>EPs, Albums and Demos</li>
            <li>Video</li>
            <li>Sound to Motion Picture</li>
            <li>Composision and Arangement</li> -->
            
        <!-- </div> -->
        <div class="sitemap">
            <router-link to="/artists">
            <h1><router-link to="/artists">Artists</router-link></h1>
            <li>Featured Artists</li>
            <li>Testimonials</li>
            </router-link>

        </div>
        <div class="sitemap">
            <router-link to="/rates">
            <h1><router-link to="/rates">Rates &amp; Terms</router-link></h1>
            <li>Rates</li>
            <li>Terms and Conditions</li>
            </router-link>
        </div>
        <div class="sitemap">
            <router-link to="/contact">
            <h1><router-link to="/contact">Contact</router-link></h1>
            <li>Contact Info</li>
            <li>FAQs</li>
            <li>Map &amp; Address</li>
            </router-link>
            
        </div>
    </div>
    <div class="page black colophon2">
        <div class="social">
            <a href="https://www.facebook.com/CopseCornerMusic/"><i class="fab fa-facebook"></i></a>
            <a href="https://www.instagram.com/copsecornermusic/"><i class="fab fa-instagram"></i></a>
            <a href="https://twitter.com/copsecornermuso"><i class="fab fa-twitter"></i></a>
        </div>
            2018 Copse Corner Music Production
    </div>
</div>
</template>

<script>
export default {
  name: 'colophon'
}
</script>

<style scoped lang="scss">

.social{
    font-size: xx-large;
    margin-bottom:0.5em;
    i{
        padding:0.5em;
    }
}
a{
  color: white;
  text-decoration: none;
  &:hover{
    color:orange;
  }
}
.colophon{
    display: flex;

    min-height: 0;
    height: auto;
    text-align: center;
}
.sitemap{
    flex:1 1 33%;
    padding:1em;
    text-align: center;
    padding-bottom:1em;

}
.sitemap h1{
    font-size: large;
    color:#777;
}
.sitemap ul{
  padding: 0; margin:0;
}
.sitemap li{
    list-style: none;
    color: #666;
}
.colophon2{
    text-align:center;
    min-height: 0;
    height: auto;
    padding-bottom:2em;
    padding-top:0;
    color:#777;
    font-family: 'Source Sans Pro';
}

@media only screen and (max-width: 600px) {
      .colophon{
        flex-wrap: wrap;
    }
    .sitemap{
        flex: 1 1 49%;
    }
}
</style>
